module.exports = __webpack_public_path__ + "static/media/sound.34133f07.svg";